import type { DetailedProduct } from './ProductDetailsPage';

export function getProductStructuredData(product: DetailedProduct) {
    return {
        '@context': 'https://schema.org' as const,
        '@type': 'Product',
        name: product.name,
        description: product.main_category?.name + (product.taste ? ', ' + product.taste : ''),
        offers: {
            '@type': 'Offer',
            price: product.price.value,
            priceCurrency: 'NOK',
        },
        image: product.images?.find((image) => image.format === 'product')?.url,
        brand: product.main_producer?.name
            ? {
                  '@type': 'Brand',
                  name: product.main_producer.name,
              }
            : null,
        url: product.url,
        keywords: product.stickers?.map((sticker) => sticker.title) ?? [],
        size: product.volume?.formattedValue ?? null,
        countryOfOrigin: product.main_country?.name ?? null,
        color: product.color,
        productionDate: product.year != '0000' ? product.year : '',
    };
}

function addToDescription(desc: string, additional: string) {
    if (desc.length + additional.length <= 130) {
        return desc + additional;
    }
    return desc;
}

export const createMetaDescription = (product: DetailedProduct) => {
    switch (product.code) {
        case 'gavekort':
            return 'Bestill fysisk gavekort fra Vinmonopolet og få det levert hjem i posten. Praktisk gave som kan brukes på alle Vinmonopol.';
        case 'egavekort':
            return 'Kjøp digitalt gavekort fra Vinmonopolet. Print selv eller send videre til mottaker. En enkel løsning når du trenger en gave raskt.';
        default: {
            let description = product.main_sub_category?.name ?? product.main_category?.name + '';
            description = addToDescription(description, product.taste ? '. ' + product.taste : '');
            description = addToDescription(description, product.smell ? ' ' + product.smell : '');
            description = addToDescription(description, ' ' + product.price.formattedValue);
            description = addToDescription(description, product.volume?.formattedValue ? ', ' + product.volume?.formattedValue : '');
            return description;
        }
    }
};
